import React from 'react';
import { Link } from 'react-router-dom';
import { FaCrown, FaBook, FaUserMinus } from 'react-icons/fa';

export function MemberCard({ member, isMemberOwner, onRemove }) {
  return (
    <div
      className={`bg-white rounded-xl border ${isMemberOwner ? 'border-amber-400 ring-2 ring-amber-200' : 'border-gray-200 hover:border-blue-300'} transition p-6 group relative`}
      data-testid={`member-card-${member.user_id}`}
    >
      <div className="flex items-center space-x-4">
        {member.picture ? (
          <img
            src={member.picture}
            alt={member.name}
            className="w-12 h-12 rounded-full"
          />
        ) : (
          <div className="w-12 h-12 rounded-full bg-blue-100 flex items-center justify-center">
            <span className="text-blue-600 font-bold text-xl">
              {member.name?.charAt(0).toUpperCase()}
            </span>
          </div>
        )}
        <div className="flex-1">
          <div className="flex items-center gap-2">
            <h3 className="text-lg font-bold text-gray-800">{member.name}</h3>
            {isMemberOwner && (
              <span className="inline-flex items-center gap-1 px-2 py-0.5 bg-amber-100 text-amber-700 text-xs font-medium rounded-full">
                <FaCrown className="text-amber-500" /> Owner
              </span>
            )}
          </div>
          <p className="text-sm text-gray-600">{member.email}</p>
        </div>
      </div>
      {/* Hover hint for assigning roles */}
      <div className="absolute inset-0 bg-blue-600/90 rounded-xl opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center">
        <Link 
          to="/role-guide" 
          className="text-white text-center px-4"
          onClick={(e) => e.stopPropagation()}
        >
          <FaBook className="text-2xl mx-auto mb-2" />
          <p className="font-medium">Assign a role to this member</p>
          <p className="text-xs text-blue-200 mt-1">Go to Roles tab or view Role Guide</p>
        </Link>
      </div>
      {onRemove && !isMemberOwner && (
        <button
          type="button"
          onClick={() => onRemove(member)}
          className="absolute top-2 right-2 z-20 flex items-center gap-1 px-2 py-1 text-xs font-medium text-red-600 bg-white border border-red-200 rounded-md hover:bg-red-50 transition-colors"
          data-testid={`remove-member-${member.user_id}-btn`}
        >
          <FaUserMinus /> Remove
        </button>
      )}
    </div>
  );
}
